var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 13.6083C8.00839 13.6083 6.39172 11.9916 6.39172 9.99993C6.39172 8.00827 8.00839 6.3916 10.0001 6.3916C11.9917 6.3916 13.6084 8.00827 13.6084 9.99993C13.6084 11.9916 11.9917 13.6083 10.0001 13.6083ZM10.0001 7.6416C8.70006 7.6416 7.64172 8.69993 7.64172 9.99993C7.64172 11.2999 8.70006 12.3583 10.0001 12.3583C11.3001 12.3583 12.3584 11.2999 12.3584 9.99993C12.3584 8.69993 11.3001 7.6416 10.0001 7.6416Z",
    fill: "#6E6B7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.5167C6.86669 17.5167 3.90836 15.6834 1.87502 12.5001C0.991691 11.1251 0.991691 8.8834 1.87502 7.50007C3.91669 4.31673 6.87502 2.4834 10 2.4834C13.125 2.4834 16.0834 4.31673 18.1167 7.50007C19 8.87507 19 11.1167 18.1167 12.5001C16.0834 15.6834 13.125 17.5167 10 17.5167ZM10 3.7334C7.30836 3.7334 4.73336 5.35007 2.93336 8.17507C2.30836 9.15007 2.30836 10.8501 2.93336 11.8251C4.73336 14.6501 7.30836 16.2667 10 16.2667C12.6917 16.2667 15.2667 14.6501 17.0667 11.8251C17.6917 10.8501 17.6917 9.15007 17.0667 8.17507C15.2667 5.35007 12.6917 3.7334 10 3.7334Z",
    fill: "#6E6B7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye1);
export default __webpack_public_path__ + "static/media/eye1.d56e3e0e0ced69f7a9e1e1aab112f319.svg";
export { ForwardRef as ReactComponent };